/**
 * Compare avatars by path only so rotating SAS/query params do not count as a new image.
 */
export function stableAvatarUrlKey(
  url: string | null | undefined,
): string | null {
  if (url == null || url === '') return null;
  const u = url.trim();
  const q = u.indexOf('?');
  return q === -1 ? u : u.slice(0, q);
}
